module.exports = __webpack_public_path__ + "img/GORDIC-logo-w.svg";